export function downloadStringAsFile(data: any, fileName: string, callback?: () => void): void {
    const text = `data:text/json;charset=utf-8,${encodeURIComponent(data)}`;
    const link = document.createElement("a");
    link.href = text;
    link.download = fileName;
    link.click();

    if (callback) {
        callback();
    }
}

export function downloadBase64AsFile(data: string, filename: string, callback?: () => void): void {
    const linkData = "data:application/octet-stream;base64," + data;
    const link = document.createElement("a");
    link.href = linkData;
    link.download = filename;
    link.click();

    if (callback) {
        callback();
    }
}

export function downloadBlobAsCsvFile(data: BlobPart, filename: string, callback?: () => void): void {
    let blob = new Blob([data], {type: "application/csv;charset=utf-8;"});
    let link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.style.display = "none";
    link.download = `${filename}.csv`;
    link.click();

    if (callback) {
        callback();
    }
}

export function downloadBlobAsFile(data: any, filename: string, callback?: () => void): void {
    const href = URL.createObjectURL(data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename); //or any other extension
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
    URL.revokeObjectURL(href);
}